import { useEffect, useState } from "react";
import axios from "axios";
export default function ApiBusqueda360(url, params) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);


  useEffect(() => {
    if ((url !== null) && (params !== null)){
      const hacerSolicitud = async () => {
        setLoading(true);
        setError(null);
        const config = {
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
        };
        try {
          const responser = await axios.post(url, params, config);
          setData(responser.data);
          setLoading(false);
        } catch (error) {
          setLoading(false);
          setError(error);
          console.error(error)
        }
      };
      hacerSolicitud();
    }
  }, []); 
  return {data, loading, error};
}